export const ExtractAndCleanPhoneNumbersAsText = (inputString) => {
    // Kiểm tra input rỗng
    if (!inputString) return '';

    try {
        // 1. Loại bỏ mọi ký tự không phải số hoặc khoảng trắng
        const sanitizedInput = inputString.replace(/[^0-9\s\-\.\(\)]/g, ' ');

        // 2. Tách tất cả chuỗi số điện thoại từ input
        const phonePattern = /\b(?:84|0)?[0-9]{2,3}(?:[\s\-\.]*[0-9]{3}){2,3}\b/g; // Regex cải tiến để xử lý khoảng trắng và ký tự đặc biệt
        const matches = sanitizedInput.match(phonePattern); // Lấy tất cả số từ input

        console.log("🚀 ~ ExtractAndCleanPhoneNumbersAsText ~ matches:", matches); // Log kết quả matches

        // 3. Nếu không tìm thấy số nào, trả về chuỗi rỗng
        if (!matches) return '';

        // 4. Làm sạch từng số điện thoại và lọc số hợp lệ
        const cleanedNumbers = matches
            .map(phone => CleanPhoneNumber(phone.trim())) // Làm sạch từng số
            .filter(number => number); // Loại bỏ số không hợp lệ

        // 5. Ghép các số điện thoại thành chuỗi với dấu cách
        return cleanedNumbers.join(' ');
    } catch (error) {
        console.log('Error extracting and cleaning phone numbers:', error);
        return '';
    }
};


// Hàm làm sạch số điện thoại
export const CleanPhoneNumber = (phoneNumber) => {
    
    if (!phoneNumber) return '';

    try {
        // Chuyển về chuỗi và chỉ giữ lại số
        let cleanedNumber = phoneNumber.toString().replace(/[^0-9]/g, ''); // Chỉ giữ lại số

        // Xử lý đầu số
        if (cleanedNumber.startsWith('84')) {
            cleanedNumber = '0' + cleanedNumber.substring(2);
        } else if (!cleanedNumber.startsWith('0')) {
            cleanedNumber = '0' + cleanedNumber;
        }

        // Kiểm tra độ dài hợp lệ (9-11 ký tự)
        if (cleanedNumber.length < 8 || cleanedNumber.length > 11) return '';

        // Xác định loại số và kiểm tra đầu số
        const validPrefixesMobile = ['03', '05', '07', '08', '09']; // Đầu số di động
        const validPrefixesLandline = ['02']; // Đầu số điện thoại bàn
        const validPrefixesService = ['1900', '1800']; // Đầu số tổng đài

        if (cleanedNumber.length === 10) {
            // Số di động
            if (!validPrefixesMobile.some(prefix => cleanedNumber.startsWith(prefix))) {
                return '';
            }
        } else if (cleanedNumber.length === 11) {
            // Số điện thoại bàn
            if (!validPrefixesLandline.some(prefix => cleanedNumber.startsWith(prefix))) {
                return '';
            }
        } else if (cleanedNumber.length === 8 || cleanedNumber.length === 9 || cleanedNumber.length === 10) {
            // Số tổng đài
            if (!validPrefixesService.some(prefix => cleanedNumber.startsWith(prefix))) {
                return '';
            }
        } else {
            return ''; // Không hợp lệ
        }

        return cleanedNumber;
    } catch (error) {
        console.log('Error cleaning phone number:', error);
        return '';
    }
};
